<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Claims for removal</p>
          <div>
            <el-tooltip content="Release claims" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click="releaseAll()"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <Claims />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Claims from '../components/youtube/claims/RemovalClaims'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Claims
  },

  computed: {
    ...mapState('youtubeRemovalClaims', ['loading'])
  },

  methods: {
    ...mapActions('youtubeRemovalClaims', ['releaseAllClaims']),
    releaseAll() {
      this.releaseAllClaims()
    }
  }
}
</script>
